import React from "react";
import { connectStats } from "react-instantsearch-dom";
import "./NoOfProducts.css";
import PropTypes from "prop-types";

const NoOfProducts = ({ nbHits }) => (
  <div className={"no-of-products"}>{nbHits} products found</div>
);

NoOfProducts.propTypes = {
  nbHits: PropTypes.number
}

export default connectStats(NoOfProducts);
